module.exports = __webpack_public_path__ + "img/thermometer.aec258e7.svg";